module.exports = __webpack_public_path__ + "static/media/apollo-corner.74aaae78.jpg";